import React, { FC, useEffect, useState } from 'react';
import { Button, Flex } from '@chakra-ui/react';

import { Dialog } from '@app/components/common/modals';
import { SwitchField, TextField } from '@app/components/common';
import { useQueryTable } from '@app/components/common/table/query-table';
import { useApi } from '@app/hooks';

interface CreateDMPTypeProps {
  open: boolean;
  setOpen(value: boolean): void;
  initial?: EntityBase;
}

const EditDMPType: FC<CreateDMPTypeProps> = ({ open, setOpen, initial }) => {
  const [value, setValue] = useState<string>(initial?.name || '');
  const [is_active, setIsActive] = useState<boolean>(initial?.is_active || false);
  const [loading, setLoading] = useState(false);
  const { refetch } = useQueryTable();
  const api = useApi();

  const onSubmit = async () => {
    setLoading(true);
    if (initial) {
      await api.stands.updateDMPType({ id: Number(initial.id), name: value, is_active });
    } else {
      await api.stands.createDMPType({ name: value });
    }
    setLoading(false);
    setOpen(false);
    refetch();
  };

  useEffect(() => {
    setValue(initial?.name || '');
    setIsActive(initial?.is_active);
  }, [initial]);

  return (
    <Dialog
      title="Тип ДМП"
      open={open}
      onClose={() => setOpen(false)}
      loading={loading}
      actions={
        <>
          <Button onClick={onSubmit}>
            {!initial ? 'Добавить' : 'Изменить'}
          </Button>
        </>
      }
    >
      <Flex mb={1} flexDirection='column' gap={4}>
        <TextField
          multiline
          rows={10}
          id=""
          label="Значение"
          value={value}
          onChange={setValue}
        />
        {!!initial && <SwitchField 
          label='Активен'
          value={is_active}
          onChange={setIsActive}
          id='is_active'
        />}
      </Flex>
    </Dialog>
  );
};

export default EditDMPType;
